import React from 'react'
import { Link } from 'react-router-dom'
function AbouttheCompany() {
  return (
    <div>
      <div className="about10 sp8">
    <div className="container">
        <div className="row">
            <div className="col-lg-5">
                <div className="about10-heading heading10">
                    <h5 data-aos="fade-left" data-aos-duration="900" className="aos-init aos-animate"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" title="Empowering Businesses with Exceptional Talent & HR Solutions">
                    <path d="M9.45001 17.8772C14.2115 17.6442 18 13.7338 18 8.94408C18 7.4743 17.6433 6.08732 17.0111 4.86399C14.4764 6.3183 13.2091 7.04546 12.2507 8.02546C11.1061 9.19582 10.2724 10.6308 9.82481 12.201C9.45001 13.5159 9.45001 14.9697 9.45001 17.8772Z" fill="#02111A"></path>
                    <path d="M8.55001 17.8772C3.78851 17.6442 0 13.7338 0 8.94408C0 7.47429 0.356744 6.08731 0.988876 4.86398C3.52358 6.3183 4.79093 7.04546 5.74937 8.02547C6.89397 9.19583 7.72761 10.6308 8.17521 12.2011C8.55001 13.5159 8.55001 14.9697 8.55001 17.8772Z" fill="#02111A"></path>
                    <path d="M1.43959 4.08981C3.97405 5.54399 5.24127 6.27107 6.57492 6.60594C8.16664 7.00559 9.83338 7.00559 11.4251 6.60594C12.7587 6.27108 14.026 5.54399 16.5604 4.08982C14.9571 1.62862 12.1699 0 9 0C5.8301 0 3.04295 1.62862 1.43959 4.08981Z" fill="#02111A"></path>
                    </svg> About Company</h5>
                    <div className="space16"></div>
                    <h2 data-aos="fade-left" data-aos-duration="1000" className="aos-init aos-animate" title='Empowering Businesses with Exceptional Talent & HR Solutions'>Bridging the Gap Between Employers and Talent</h2>
                    <div className="space40"></div>
                    <div className="img1 aos-init aos-animate" data-aos="fade-left" data-aos-duration="1100">
                        <img src="assets/img/all-images/about/about-img7.png"alt=""/>
                    </div>
                </div>
            </div>
            <div className="col-lg-4 aos-init aos-animate" data-aos="zoom-in-up" data-aos-duration="1000">
                <div className="img2">
                    <img src="assets/img/all-images/about/DSA.png"alt=""/>
                </div>
            </div>
            <div className="col-lg-3">
                <div className="space100 d-lg-block d-none"></div>
                <div className="space100 d-lg-block d-none"></div>
                <div className="space60"></div>
                <div className="space6"></div>
                <div className="about-pera-area heading9">
                    <div className="arrow-btnarea">
                        <Link to="/About">
                            <div className="content" bis_skin_checked="1">
                              <h6 className="circle rotateme" title='Empowering Businesses with Exceptional Talent & HR Solutions'>
                                 <span style={{ transform: 'rotate(0deg)' }}>J</span>
                                <span style={{ transform: 'rotate(17deg)' }}>B</span>
                                <span style={{ transform: 'rotate(34deg)' }}>Y</span>
                                 <span style={{ transform: 'rotate(45deg)' }}>.</span>
                                <span style={{ transform: 'rotate(51deg)' }}>T</span>
                                <span style={{ transform: 'rotate(68deg)' }}>A</span>
                                <span style={{ transform: 'rotate(85deg)' }}>L</span>
                                <span style={{ transform: 'rotate(102deg)' }}>E</span>
                                <span style={{ transform: 'rotate(119deg)' }}>N</span>
                                <span style={{ transform: 'rotate(136deg)' }}>T</span>
                                 <span style={{ transform: 'rotate(145deg)' }}>.</span>
                                <span style={{ transform: 'rotate(153deg)' }}>A</span>
                                <span style={{ transform: 'rotate(170deg)' }}>C</span>
                                <span style={{ transform: 'rotate(187deg)' }}>Q</span>
                                <span style={{ transform: 'rotate(204deg)' }}>U</span>
                                <span style={{ transform: 'rotate(221deg)' }}>I</span>
                                <span style={{ transform: 'rotate(238deg)' }}>S</span>
                                <span style={{ transform: 'rotate(255deg)' }}>T</span>
                                <span style={{ transform: 'rotate(272deg)' }}>I</span>
                                <span style={{ transform: 'rotate(289deg)' }}>O</span>
                                <span style={{ transform: 'rotate(306deg)' }}>N</span>
                                <span style={{ transform: 'rotate(323deg)' }}>S</span>
                               

                                </h6>
                            </div>
                            <img src="assets/img/icons/arrow1.svg"alt="" className="arrow1"/>
                        </Link>
                    </div>
                    <div className="space32"></div>
                    <p data-aos="fade-left" data-aos-duration="1000" className="aos-init aos-animate">We offer comprehensive corporate talent solutions, including manpower sourcing, employee training, professional grooming, performance management systems, KRA/KPI development, and company policy structuring.</p>
                    <div className="space32"></div>
                    <div className="btn-area1 aos-init aos-animate" data-aos="fade-left" data-aos-duration="1100">
                        <Link to="/About" className="vl-btn10">Explore AGency <span><i className="fa-solid fa-arrow-right"></i></span></Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
    </div>
  )
}

export default AbouttheCompany
